<template>
  <div>
    <div v-if="cancelFree" class="notification is-success is-light">
      You're in luck! This booking is eligible for free cancellation.
    </div>
    <p>{{ displayMessage }}</p>
  </div>
</template>

<script>
export default {
  props: {
    cancelPolicy: {
      type: Object,
      required: true,
    },
    pnrCxlText: {
      type: String,
      required: false,
    },
    // Props for customization
    maxWidth: {
      type: String,
      required: false,
      default: '600px', 
    },
  },
  computed: {
    //Parse freetext (Array) from HotelReservationDetails
    cancelFreetext() {
      let freetext = this.$helpers.getSafe(
        () => this.cancelPolicy.infoMsgAndCancelPolicies.freeText
      );

      let msgs = [].concat(freetext);
      let text = null;
      msgs.forEach((msg) => {
        text += msg;
      });
      return text;
    },
    cancelFee() {
      return this.cancelPolicy.cancelFee;
    },
    cancelNights() {
      return this.cancelPolicy.cancelNights;
    },
    cancelDate() {
      return this.cancelPolicy.cancelDate;
    },
    cancelFree() {
      return this.cancelPolicy.cancelFree;
    },
    displayMessage() {
      let message =
        "Cancellation may be subject to fees or penalties by the hotel.";
      // Ex 1: Cancel before Thursday, January 27, 2022 23:59 local hotel time to avoid a charge of 277.59 USD
      if (this.cancelDate && this.cancelFee) {
        message =
          "Cancel before " +
          this.cancelDate.date +
          " at " +
          this.cancelDate.time +
          " local hotel time to avoid a charge of $" +
          this.cancelFee + '.';
      // Ex 1: Cancel before Thursday, January 27, 2022 23:59 local hotel time to avoid a charge of 277.59 USD    
      } else if (this.cancelDate && this.cancelNights) {
        message =
          "Cancellation before " +
          this.cancelDate.date +
          " at " +
          this.cancelDate.time +
          " local hotel time to avoid a " +
          this.cancelNights +
          " night(s) cancellation penalty.";
      } else if (this.cancelDate) {
        // Ex 2: Cancel for free until Tue, Jan 18, 2022 local hotel time.
        message =
          "Cancel for free until " +
          this.cancelDate.date +
          " at " +
          this.cancelDate.time +
          " local hotel time.";

      } else if (this.pnrCxlText) {
        //Show freetext from the PNR
        message = this.pnrCxlText;
      }
      else if (this.cancelFreetext) {
        //Show freetext from the HotelReservationDetails
        message = this.cancelFreetext;
      }

      return message;
    },
  },
};
</script>

<style></style>
